<template>
  <ul :class="$style.segmentedControl">
    <li v-for="item in list" :key="item.value" :class="$style.segmentedControlItem">
      <AtomsConsumerButton
        type="button"
        :class="[$style.button, { [$style.active]: localModelValue === item.value }]"
        @click="selectItem(item)"
      >
        {{ item.key }}
      </AtomsConsumerButton>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import AtomsConsumerButton from "@tential/consumer-component/components/atoms/consumer/Button.vue"

type ListItem = {
  key: string
  value: string
}

const props = defineProps<{
  list: ListItem[]
  modelValue: string
}>()

const emit = defineEmits<{
  (e: "update:modelValue", modelValue: string): void
  (e: "onSelectItem"): void
}>()

const localModelValue = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    emit("update:modelValue", value)
  },
})

const selectItem = (item: ListItem) => {
  localModelValue.value = item.value
  emit("onSelectItem")
}
</script>

<style scoped module lang="scss">
.segmentedControl {
  display: flex;
  align-items: stretch;
  width: 100%;
  border-radius: 6px;
  background: $white;
  padding: 0;
  white-space: nowrap;
  overflow-x: scroll;
  flex-wrap: nowrap;
  border: 1px solid $secondary-40;
  @include md {
    overflow-x: inherit;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  li.segmentedControlItem {
    flex: 1;
    list-style-type: none;
    margin: 0;
    border-radius: 6px;
    text-align: center;
    .button {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 6px;
      border: none;
      padding: 0.5rem 1.5rem;
      color: black;
      font-size: $font-size-12;
      font-weight: normal;
      transition: all 0.2s ease;
      @include md {
        font-size: $font-size-14;
        padding: 0.5rem 1.5rem;
      }
      &:hover {
        background: $secondary-40;
      }
      &:focus {
        outline: none;
      }
      &.active {
        font-weight: normal;
        color: $primary;
        background: $secondary-20;
        @include md {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
